import Colr from 'colr'

export const darken = (hexColor, percent) =>
  Colr.fromHex(hexColor).darken(percent).toHex()

export const lighten = (hexColor, percent) =>
  Colr.fromHex(hexColor).lighten(percent).toHex()
